import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { AngularServices, utils } from '../../../../modules/core';
import { API } from '../../../../vendor/api';
import { getApolloSessionStorageKey } from 'utility/sessionStorage/helpers';
export default class UserCallQualityRatingTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Call Rated';
    }
    start() {
        this.VideoProviderFactory = this.$injector.get(AngularServices.VideoProviderFactory);
        this.$rootScope.$on(RootScopeEvents.VIDEO_CHAT.USER_CALL_RATING, ($e, data) => {
            data.data = data.data.map((element) => utils.snakeToSpaced(element));
            const search = new URLSearchParams(window.location.search);
            const surveyType = search.get('survey') === 'true' ? 'apollo' : null;
            let sessionId = null;
            let vendor = null;
            let roomId = null;
            let isApollo = false;
            let channel = null;
            let qualityOptimizationEnabled = undefined;
            if (surveyType === 'apollo') {
                const apolloValues = getApolloSessionStorageKey();
                sessionId = apolloValues.dbSessionId;
                vendor = apolloValues.vendor;
                roomId = apolloValues.roomId;
                isApollo = true;
                channel = apolloValues.sessionId;
                qualityOptimizationEnabled =
                    apolloValues.isUpgradeDowngradeVideoQualityEnabled;
            }
            else {
                const segmentData = this.stateWatcher.getSegmentTrackData();
                sessionId = segmentData.sessionId;
                roomId = segmentData.roomId;
                vendor = 'Vonage';
                channel = this.VideoProviderFactory.activeProvider.getSessionId();
            }
            const customTrackData = {
                ...data,
                surveyType,
                sessionId,
                vendor,
                roomId,
                is_apollo: isApollo,
                callInitiator: undefined,
                channel,
                /**
                 * Is upgrade / downgrade quality applied for a participant video when it switches between small/medium/large/hidden modes.
                 * @description https://doxyme.atlassian.net/browse/CS-10645
                 * @TODO To be removed after A/B testing - https://doxyme.atlassian.net/browse/CS-16058
                 */
                qualityOptimizationEnabled,
            };
            const context = this.stateWatcher.getSegmentContext();
            this.trackSegment(customTrackData, false, context);
            const { noSoundDetected } = this.stateWatcher.getTrackData();
            API.callRating.save({
                sessionId,
                noSoundDetected,
                rating: data.rating,
                data: data.data || [],
                comment: data.comment || '',
                isProviderFeedback: data.isProviderFeedback,
                surveyType,
                vendor,
            });
        });
    }
}
